<template>
  <span class="requisite-status-dot" :class="'requisite-status-dot--' + status" v-b-tooltip.hover :title="helper.trans('requisites.status_' + status)"></span>
</template>

<script lang="ts">

import {computed, defineComponent, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import {resolveFillStatus} from "@/service/requisiteFrozenSums";

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<TraderRequisitesDTO>,
      required: true,
    },
  },
  setup(props) {
    const status = computed(() => resolveFillStatus(props.item))

    return {
      status,
      helper,
    }
  }
})
</script>
